/**
 * Helpers para sincronizar filtros (período + comparar) com search params
 * da rota analytics. Cada rota declara seu próprio `validateSearch` com
 * `analyticsSearchSchema` para o TanStack Router tipar as queries.
 */
import { type AnalyticsPeriod } from '@idpe/schema';
import { z } from 'zod';

export const analyticsSearchSchema = z.object({
  range: z.enum(['7d', '30d', '90d', 'custom']).optional(),
  from: z.string().optional(),
  to: z.string().optional(),
  comparar: z
    .union([z.boolean(), z.literal('true'), z.literal('false')])
    .optional()
    .transform((v) => v === true || v === 'true'),
});
export type AnalyticsSearch = z.infer<typeof analyticsSearchSchema>;

/** Converte search params (já validados) em AnalyticsPeriod. */
export function searchToPeriod(search: AnalyticsSearch): AnalyticsPeriod {
  const range = search.range ?? '30d';
  return {
    range,
    from: search.from,
    to: search.to,
    comparar: !!search.comparar,
  };
}
